import styled from "styled-components";
import DesignConstants from "../../constants/DesignConstants";
import PhaseSixIcon from "../phaseSixIcon/PhaseSixIcon";

export const AccordionTabWrapper = styled.div`
    background: white;
    border-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
`;

export const AccordionTabSummaryWrapper = styled.div<{ hideHeader?: boolean; isActive?: boolean }>`
    position: sticky;
    top: ${(props) => (props.hideHeader ? 0 : "116px")};
    background: white;
    z-index: 2;
    border-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
    cursor: ${({ isActive }) => !isActive && "pointer"};

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        top: ${(props) => (props.hideHeader ? 0 : "112px")};
    }
`;

export const AccordionTabSummaryContentWrapper = styled.div<{ borderBottom?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${DesignConstants.SPACES.S};
    padding-bottom: ${(props) => (props.borderBottom ? DesignConstants.SPACES.XS : "")};
    border-bottom: ${(props) => (props.borderBottom ? DesignConstants.BORDERS.THIN_GREY : "")};
`;

export const AccordionTabSummary = styled.div<{ hidden?: boolean }>`
    display: ${(props) => (props.hidden ? "none" : "flex")};
    align-items: center;
    gap: ${DesignConstants.SPACES.XS};

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        flex-wrap: wrap;
    }
`;

export const AccordionTabSummaryTitleGroup = styled.div`
    display: flex;
    align-items: center;
    gap: ${DesignConstants.SPACES.XS};
    flex-shrink: 0;
`;

export const AccordionTabSummaryDescriptionGroup = styled.div`
    display: flex;
    align-items: center;
    gap: ${DesignConstants.SPACES.XS};
`;

export const AccordionTabSummaryItem = styled.div`
    display: flex;
    align-items: center;
`;

export const AccordionTabText = styled.p<{ primaryColor?: boolean; isHighlighted?: boolean }>`
    font-weight: ${({ isHighlighted }) => isHighlighted && DesignConstants.FONT_WEIGHTS.SEMI_BOLD};
    font-size: ${DesignConstants.FONT_SIZES.L};
    color: ${(props) =>
        props.primaryColor ? `var(--creation-primary-color, ${DesignConstants.COLORS.P6_ORANGE})` : ""};
`;

export const StyledIcon = styled(PhaseSixIcon)<{
    $mediumWeight?: boolean;
    $primaryColor?: boolean;
}>`
    font-size: ${DesignConstants.FONT_SIZES.XXL};
    font-weight: ${(props) =>
        props.$mediumWeight ? DesignConstants.FONT_WEIGHTS.MEDIUM : DesignConstants.FONT_WEIGHTS.NORMAL};
    color: ${(props) =>
        props.$primaryColor ? `var(--creation-primary-color, ${DesignConstants.COLORS.P6_ORANGE})` : ""};
`;

export const AccordionTabDetailsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${DesignConstants.SPACES.S};
    padding: ${DesignConstants.SPACES.S};
`;

//TODO: StickyWrapper is a temporary solution until we improve the footer
// changing the position from fixed to sticky might help with the footer height change
export const StickyWrapper = styled.div`
    position: sticky;
    bottom: ${DesignConstants.SPACES.XXL};
    background: ${DesignConstants.COLORS.BACKGROUND_LIGHT};
    width: calc(100vw - 2rem);
    max-width: calc(${process.env.REACT_APP_UPPER_GRID_STEP_BORDER}px - 2rem);
    padding: ${DesignConstants.SPACES.XS} 0;
`;
